/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadOnlyMonitoredObjectSerializer
 */
export interface ReadOnlyMonitoredObjectSerializer {
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectSerializer
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectSerializer
     */
    registrationNumber: string;
}

export function ReadOnlyMonitoredObjectSerializerFromJSON(json: any): ReadOnlyMonitoredObjectSerializer {
    return ReadOnlyMonitoredObjectSerializerFromJSONTyped(json, false);
}

export function ReadOnlyMonitoredObjectSerializerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyMonitoredObjectSerializer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'registrationNumber': json['registration_number'],
    };
}

export function ReadOnlyMonitoredObjectSerializerToJSON(value?: ReadOnlyMonitoredObjectSerializer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'registration_number': value.registrationNumber,
    };
}


